const pinLevels = {
  Guest: 1, //Not used
  AssociateIbo: 2,
  Platinum: 4,
  Emerald: 8,
  Diamond: 16,
};

const platformsMap = {
  Web: 1,
  iOS: 2,
  Android: 4,
};

export function convertPermissionsToBitmask(permissions = []) {
  return permissions.reduce((acc, key) => acc | (pinLevels[key] || 0), 0);
}

export function convertPlatformsToBitmask(platforms = []) {
  return platforms.reduce((acc, key) => acc | (platformsMap[key] || 0), 0);
}
